module.exports = __webpack_public_path__ + "static/media/facebook-icon.a460ac29.svg";